import { render, staticRenderFns } from "./accountBalanceCenter.vue?vue&type=template&id=54124d74&scoped=true&"
import script from "./accountBalanceCenter.vue?vue&type=script&lang=js&"
export * from "./accountBalanceCenter.vue?vue&type=script&lang=js&"
import style0 from "./accountBalanceCenter.vue?vue&type=style&index=0&id=54124d74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54124d74",
  null
  
)

export default component.exports